import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { publishRefuelingContract } from '../../api/refueling-contract.ts';
import type { PublishRefuelingContractRequest } from '../../api/requests/refueling-contract-request.ts';

export default function usePublishRefuelingContract(): UseMutationResult<
  string,
  Error,
  PublishRefuelingContractRequest
> {
  return useMutation({
    mutationFn: publishRefuelingContract,
  });
}
